import React from 'react'
import { Card, Row, Col, Input, Typography, Collapse, Space, Button } from 'antd'
import PropTypes from 'prop-types'
import { ANCHOR_LINK_KEYS } from '~constants'
import { MultiSelectDropdown } from '~stories'

import styles from './AnchorLinks.module.css'
import DownArrow from './DownArrow'
import UpArrow from './UpArrow'
const { Title } = Typography
const { Panel } = Collapse

const AnchorLinks = ({ anchorLinks, setAnchorLinks }) => {
  const deleteLink = (event, index) => {
    event.stopPropagation()
    const temp = [...anchorLinks]
    if (index !== -1) {
      temp.splice(index, 1)
    }
    setAnchorLinks(temp)
  }
  const handleMoveUp = (id) => {
    const tempList = [...anchorLinks]
    if (id > 0) {
      const el = tempList[id]
      tempList[id] = tempList[id - 1]
      tempList[id - 1] = el
      setAnchorLinks([...tempList])
    }
  }
  const handleMoveDown = (id) => {
    const tempList = [...anchorLinks]
    if (id !== -1 && id < tempList.length - 1) {
      const el = tempList[id]
      tempList[id] = tempList[id + 1]
      tempList[id + 1] = el
      setAnchorLinks([...tempList])
    }
  }

  const handleLabel = (index, value) => {
    const temp = [...anchorLinks]
    temp[index] = { ...temp[index], label: value }
    if (!temp[index].id) {
      temp[index] = { ...temp[index], label: value }
    }
    setAnchorLinks([...temp])
  }

  const handleAnchorLinkChange = (index, selectedItem) => {
    const temp = [...anchorLinks]
    temp[index] = { ...temp[index], key: selectedItem }
    setAnchorLinks([...temp])
  }

  return (
    <div className={styles['anchor-container']}>
      { anchorLinks && <Collapse accordion defaultActiveKey={['0']} expandIconPosition='right' style={{ width: '100%' }}>
        {anchorLinks.length > 0 && anchorLinks.map((anchorLink, rowIndex) => (<Panel key={rowIndex} extra={<Row gutter={2}><Space>
          <Col align="left" span={4}>
            <Row gutter={[10]} style={{ width: '60px' }}>
              {rowIndex !== 0 && <Col align='right' data-testid="up-arrow" onClick={() => handleMoveUp(rowIndex)} span={12}>
                <UpArrow />
              </Col>
              }
              {anchorLinks.length - rowIndex !== 1
                ? <Col align="left" data-testid="down-arrow" onClick={() => handleMoveDown(rowIndex)} span={12}>
                  <DownArrow/>
                </Col>
                : <Col span={3} />}
            </Row>
          </Col>
          <Button danger onClick={(event) => deleteLink(event, rowIndex)} style={{ backgroundColor: '#DA0D50', color: '#fff' }}>Delete</Button>
        </Space>
        </Row>
        } header={<span style={{ fontSize: 20 }}>{anchorLink?.label}</span>}>
          <Card className={styles['card-container']}>
            <Row align={'middle'} className={styles['title-wrapper']}>
              <Title level={3}>Label</Title>
            </Row>
            <Row>
              <Col span={24}>
                <Input
                  onChange={({ target }) => handleLabel(rowIndex, target.value)}
                  value={anchorLink?.label || ''}
                />
              </Col>
            </Row>
            <br />
            <Row align={'middle'} className={styles['title-wrapper']}>
              <Title level={3}>Key</Title>
            </Row>
            <Row>
              <Col span={24}>
                {/* <Input
                  onChange={({ target }) => handleAnchorLinkChange(rowIndex, target.value)}
                  value={anchorLink?.label || ''}
                /> */}
                <MultiSelectDropdown
                  customStyle={{ width: 200 }}
                  displayField="key"
                  dropdownOptions={ANCHOR_LINK_KEYS}
                  handleChange={(event) => handleAnchorLinkChange(rowIndex, event)}
                  label=''
                  selectedItems={[anchorLink?.key]}
                  valueField="key"
                />
              </Col>
            </Row>
            <br />
          </Card>
        </Panel>))
        }
      </Collapse>}
    </div>
  )
}
AnchorLinks.propTypes = {
  anchorLinks: PropTypes.array,
  setAnchorLinks: PropTypes.func
}

export default AnchorLinks
